import createClient from "openapi-react-query";
import type { components } from "./schema";
import { fetchClient } from "./client";

export { fetchClient, BACKEND_URL } from "./client";
export const $api = createClient(fetchClient);

// Re-export commonly used response types from the generated schema
export type ProjectResponse = components["schemas"]["ProjectResponse"];
export type ProjectCreateResponse = components["schemas"]["ProjectCreateResponse"];
export type MeetingResponse = components["schemas"]["MeetingResponse"];
export type Attendee = components["schemas"]["Attendee"];
export type PrecedentResponse = components["schemas"]["PrecedentResponse"];
export type PrecedentListResponse = components["schemas"]["PrecedentListResponse"];
export type PrecedentCreate = components["schemas"]["PrecedentCreate"];
export type PrecedentUpdate = components["schemas"]["PrecedentUpdate"];
export type SharePointSite = components["schemas"]["SharePointSite"];
export type SharePointFolder = components["schemas"]["SharePointFolder"];
export type OneDriveDriveInfo = components["schemas"]["OneDriveDriveInfo"];
export type OneDriveFolder = components["schemas"]["OneDriveFolder"];
export type RecentFileResponse = components["schemas"]["RecentFileResponse"];
export type PersonResponse = components["schemas"]["PersonResponse"];
export type MeetingIntelligence = components["schemas"]["MeetingIntelligence"];
